import { forEach } from 'ramda';
import { all, call, spawn } from 'redux-saga/effects';
import { IStateModule } from './types';

export class RootSaga {
	constructor(private activeModules: IStateModule[]) {}

	getActiveModules(): IStateModule[] {
		return this.activeModules;
	}

	setActiveModules(activeModules: IStateModule[]): IStateModule[] {
		return (this.activeModules = activeModules);
	}

	getSagasFromActiveModules(): any[] {
		const sagas: any[] = [];
		if (this.getActiveModules().length) {
			forEach(module => {
				sagas.push(module.getSagas());
			}, this.getActiveModules());
		}
		return sagas;
	}

	getRootSagas(): any {
		const sagas = this.getSagasFromActiveModules();
		return function* () {
			yield all(
				sagas.map(saga =>
					spawn(function* () {
						while (true) {
							try {
								yield call(saga);
								break;
							} catch (e) {
								console.log(e);
							}
						}
					}),
				),
			);
		};
	}
}
